import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { HeaderPublicComponent } from 'src/app/shared/components/header-public/header-public.component';

@Component({
  selector: 'app-public-layout',
  imports: [RouterOutlet, FooterComponent, HeaderPublicComponent],
  templateUrl: './public-layout.component.html',
})
export class PublicLayoutComponent {}
